/*
 * @Author: your name
 * @Date: 2021-04-14 09:35:25
 * @LastEditTime: 2021-10-15 11:43:54
 * @LastEditors: Teemo Ding
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/common.ts
 */

import { randomNumber } from 'src/tools/helper';
import { EnumModuleType, EnumCarouselOptions } from '@/src/types/common/module';
import { EnumLinkType } from '@/src/types/common/linkType';

export enum EnumCollapseId {
  seoSetting = 'saleChannelProductAliasSeoSetting',
  contentDetails = 'saleChannelProductAliasDetails',
  carousel = 'saleChannelProductAliasCarousel',
  thumbnailImage = 'saleChannelProductAliasThumbnailImage',
  miniProgramPageInfo = 'salesChannelProductAliasMiniProgramPageInfo',
  miniProgramShare = 'salesChannelProductAliasMiniProgramShare',
}

import {
  useErrorOnChange,
  generateProductList,
  generateProductGrid,
  generateText,
  generateLongCanvas,
  generatePoster,
  generateCarousel,
  generateProductCarousel,
  generateLinkImg,
} from 'src/constrains/DraggableModules/tools';

export enum ProductType {
  SinglePhysical = 'SinglePhysical',
  SingleService = 'SingleService',
  SingleGiftCard = 'SingleGiftCard',
  MultiplePhysical = 'MultiplePhysical',
  MultipleVirtual = 'MultipleVirtual',
}
export interface ProductSeoSetting {
  title: string;
  description: string;
  urlSlug: string;
  customized: boolean;
  slugValid: boolean;
}

export const generateDefaultSEOSetting = (
  title?,
  description?,
): ProductSeoSetting => {
  return {
    customized: false,
    title: title || '',
    description: description || '',
    urlSlug: '',
    slugValid: true,
  };
};

export const generateDefaultLongCanvas = () => {
  return [
    {
      draggableId: randomNumber(),
      linkImage: {},
      linkType: EnumLinkType.Product,
    },
  ];
};

export const generateDefaultContentDetails = () => {
  return {
    sku: '-',
    productCode: '',
    productName: '',
    productSubtitle: '',
    productDescription: '',
    productRemarks: '',
    contentPrice: [],
    productNameDuplicate: false,
  };
};

export const generateDefaultCarousel = () => {
  return {
    sameAsOriginal: true,
    staticData: {
      moduleName: '',
      moduleType: EnumModuleType.ProductContentCarousel,
      visible: true,
      posterType: EnumCarouselOptions.One,
      autoPlay: false,
      intervalTime: 0,
    },
    dynamicData: [
      {
        draggableId: randomNumber(),
        linkModule: {
          linkImage: {
            uuid: '',
            url: '',
          },
          linkType: EnumLinkType.None,
        },
        coverImage: true,
      },
    ],
  };
};

export const generateDefaultThumbnailImage = () => {
  return {
    sameAsOriginal: true,
    linkModules: [
      {
        draggableId: randomNumber(),
        linkImage: {
          uuid: '',
          url: '',
        },
        linkType: EnumLinkType.None,
        title: '',
        subtitle: '',
      },
      {
        draggableId: randomNumber(),
        title: '',
        subtitle: '',
        linkImage: {
          uuid: '',
          url: '',
        },
        linkType: EnumLinkType.None,
      },
    ],
  };
};

export {
  useErrorOnChange,
  generateProductList,
  generateProductGrid,
  generateText,
  generateLongCanvas,
  generatePoster,
  generateCarousel,
  generateProductCarousel,
  generateLinkImg,
  EnumCarouselOptions,
  EnumModuleType,
  EnumLinkType,
};
